var map = {
	"./stemmen01.svg": 7680,
	"./stemmen02.svg": 8691,
	"./stemmen03.svg": 4962,
	"./stemmen04.svg": 3485,
	"./stemmen05.svg": 6124,
	"./stemmen06.svg": 5151,
	"./stemmen07.svg": 510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5148;